// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"32b28516","488":"b6985d5b"}[chunkId] + ".chunk.js";
};